import { render, staticRenderFns } from "./AtomCategorySpecs.vue?vue&type=template&id=38cbff46&scoped=true&"
import script from "./AtomCategorySpecs.vue?vue&type=script&lang=js&"
export * from "./AtomCategorySpecs.vue?vue&type=script&lang=js&"
import style0 from "./AtomCategorySpecs.vue?vue&type=style&index=0&id=38cbff46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cbff46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
